export default "__VITE_ASSET__lr0yjnOG__"